import { render, staticRenderFns } from "./PreviewColumnWrapperElement.vue?vue&type=template&id=5f30fbe0&"
import script from "./PreviewColumnWrapperElement.vue?vue&type=script&lang=js&"
export * from "./PreviewColumnWrapperElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports